import * as React from 'react';
import * as styles from './AdfoxLayout.css';

interface IAdfoxLayoutProps {
  children: React.ReactNode;
}

export const AdfoxLayout: React.FC<IAdfoxLayoutProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
